import * as React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

import { RED } from '../../theme/colorConstants';

const PATH_D =
  'M8.00016 1.33325C4.32016 1.33325 1.3335 4.31992 1.3335 7.99992C1.3335 11.6799 4.32016 14.6666 8.00016 14.6666C11.6802 14.6666 14.6668 11.6799 14.6668 7.99992C14.6668 4.31992 11.6802 1.33325 8.00016 1.33325ZM8.66683 11.3333H7.3335V9.99992H8.66683V11.3333ZM8.66683 8.66659H7.3335V4.66659H8.66683V8.66659Z';

const RedCircleAlertIcon = ({ width = 16, height = 16, color = RED[80] }) => (
  <SvgIcon viewBox="0 0 16 16" fill="none" sx={{ width, height, color }}>
    <path d={PATH_D} fill="currentColor" />
  </SvgIcon>
);

RedCircleAlertIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

export default RedCircleAlertIcon;
